module.exports = __webpack_public_path__ + "img/2023-10.8223485e.jpg";